const MOVE_CHANNEL_LABEL = 'א בליק אויפן בלעט';

/** הודעה אחרי העלאת סיכום, לפי מה שקרה לסיכומים הקודמים. { text, failed } */
export function introUploadMessage({ movedTitles = [], moveFailed = [] } = {}) {
  if (moveFailed.length) {
    const names = moveFailed.map((t) => `«${t}»`).join(', ');
    return {
      failed: true,
      text: `הסיכום החדש הועלה, אבל העברת ${names} ל«${MOVE_CHANNEL_LABEL}» נכשלה. הסיכום נשאר כבוי כאן, ואפשר להעביר אותו בכפתור «מעבר».`,
    };
  }
  if (movedTitles.length) {
    return { failed: false, text: `הסיכום הועלה והופעל; הקודם הועבר ל«${MOVE_CHANNEL_LABEL}»` };
  }
  return { failed: false, text: 'הסיכום הועלה והופעל' };
}
